export default __webpack_public_path__ + "static/icon-tile-bold-do-d10b1a504a0fcc61459dd175c2253994a0643f2ede514398c21f682075e3b4f0.png";